"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializeMap;
function initializeMap(latitude, longitude, mapReference) {
  return new google.maps.Map(mapReference.current, {
    center: {
      lat: latitude,
      lng: longitude
    },
    mapId: 'DEMO_MAP_ID',
    zoom: 11,
    controlSize: 40,
    mapTypeControlOptions: {
      mapTypeIds: [],
      position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
    streetViewControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
    fullscreenControl: false
  });
}